// Phase 6 - US4: Response Types (T111)

export enum AnswerType {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  CHOICE = 'CHOICE',
  CHOICES = 'CHOICES',
  DATE = 'DATE',
}

export interface AnswerData {
  questionId: string;
  answerType: AnswerType;
  textAnswer?: string;
  numericAnswer?: number;
  booleanAnswer?: boolean;
  choiceAnswers?: string[];
  dateAnswer?: string;
}

export interface ResponseSubmit {
  surveyId: string;
  answers: AnswerData[];
  deviceFingerprint?: string;
  geoLatitude?: number;
  geoLongitude?: number;
  geoConsentGiven?: boolean;
}

export interface ResponseResult {
  responseId: string;
  responseHash: string;
  submittedAt: string;
}

export interface EligibilityCheck {
  eligible: boolean;
  message?: string;
  reason?: string;
}

export interface ResponseAnswer {
  id: string;
  questionId: string;
  answerType: AnswerType;
  textAnswer?: string;
  numericAnswer?: number;
  booleanAnswer?: boolean;
  choiceAnswers?: string[];
  dateAnswer?: string;
  question?: {
    id: string;
    shortDescription: string;
    questionType: string;
  };
}

export interface ResponseData {
  id: string;
  surveyId: string;
  responseHash: string;
  submittedAt: string;
  geographicScope?: string;
  survey?: {
    id: string;
    name: string;
  };
  answers?: ResponseAnswer[];
}
